import React from "react"
import { Box, Typography } from "@material-ui/core"
import ThemeProvider from "@material-ui/styles/ThemeProvider"
import Layout from "./layout"
import SEO from "./seo"
import theme from "../theme"
export default function InformationPage({
  title,
  description,
  children,
}: {
  title: string
  description: string
  children: React.ReactNode
}) {
  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <SEO title={title} description={description} />
        <Box
          component="article"
          style={{
            maxWidth: 800,
            margin: "40px auto",
            fontFamily: theme.typography.fontFamily,
            lineHeight: 1.7,
          }}
        >
          <Typography variant="h3" component="h1" gutterBottom>
            {title}
          </Typography>
          {children}
        </Box>
      </Layout>
    </ThemeProvider>
  )
}
